import { dateComparator } from './ag-comparators'
import * as formatters from './ag-formatters'

export const textAreaStyling = {
  minWidth: 200,
  maxWidth: 300,
  autoHeight: true,
  cellStyle: {
    'white-space': 'pre-line',
    'word-wrap': 'break-word',
    'line-height': '2.0',
    'padding-top': '9px',
    'padding-bottom': '9px'
  }
}

export const textareaColDef = {
  ...textAreaStyling,
  /** Override the default value formatter to allow empty strings */
  valueFormatter: formatters.withDefault({
    defaultOn: 'nullish',
    defaultValue: ''
  }),
  filter: 'agTextColumnFilter'
}

export const numericColDef = {
  filter: 'agNumberColumnFilter',
  type: 'numericColumn',
  filterParams: {
    buttons: ['reset'],
    defaultToNothingSelected: true,
    showTooltips: true
  },
  valueFormatter: formatters.withDefault({
    defaultOn: 'nullish',
    formatter: formatters.number
  })
}

export const currencyColDef = {
  ...numericColDef,
  valueFormatter: formatters.currency
}

export const dateColDef = {
  valueFormatter: formatters.datetime.withFormat('M/D/YY'),
  filter: 'agDateColumnFilter',
  filterParams: {
    comparator: dateComparator
  }
}

export const booleanColDef = {
  valueFormatter: formatters.boolean,
  filterParams: {
    valueFormatter: formatters.boolean
  }
}

export const enumColDef = {
  valueFormatter: formatters.normalizeLabel,
  filterParams: {
    valueFormatter: formatters.normalizeLabel
  }
}

export const withTextAndSetFilters = {
  filter: 'agMultiColumnFilter',
  filterParams: {
    filters: [
      {
        filter: 'agTextColumnFilter'
      },
      {
        filter: 'agSetColumnFilter',
        filterParams: {
          defaultToNothingSelected: true,
          showTooltips: true,
          buttons: ['reset']
        }
      }
    ]
  }
}
